import { render, staticRenderFns } from "./HolidaysOverview.vue?vue&type=template&id=497fc0d0&scoped=true&"
import script from "./HolidaysOverview.vue?vue&type=script&lang=ts&"
export * from "./HolidaysOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497fc0d0",
  null
  
)

export default component.exports